import React from 'react';
import { SEO } from '@olo-web/components/atoms/SEO';
import { SEOErrorBoundary } from '@olo-web/components/atoms/SEO/SEOErrorBoundary.ui';
import { useMerchant } from '@olo-web/domain/merchants/queries/useMerchant';

export const CheckoutMeta = () => {
  const { data: merchant } = useMerchant();

  return (
    <SEOErrorBoundary fallbackTitle="Checkout" fallbackDescription="Complete your order">
      <SEO
        title={merchant?.name ? `${merchant.name} Checkout` : 'Checkout'}
        description="Complete your order"
        noIndex={true}
      />
    </SEOErrorBoundary>
  );
};
